/* eslint-disable max-lines */
import { rgb } from 'pdf-lib';

export const pdfByType = [
  {
    type: 'NON_DISCLOSURE',
    title: 'Non Disclosure Agreement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA_DEV_LLC_NDA_2021_MS_UPDATED.pdf',
    signPage: 3,
    coordinates: {
      x: 330,
      y: 310,
      height: 40,
      opacity: 1,
    },
    signDatePage: 0,
    coordinatesDate: {
      x: 350,
      y: 648,
      size: 12,
    },
    coordinatesNames: [
      {
        page: 0,
        coordinates: {
          x: 430,
          y: 636,
          size: 12,
        },
      },
      {
        page: 2,
        coordinates: {
          x: 360,
          y: 306,
          size: 12,
        },
      },
      {
        page: 3,
        coordinates: {
          x: 380,
          y: 285,
          size: 12,
        },
      },
    ],
  },
  {
    type: 'WORK_FOR_HIRE',
    title: 'Work for Hire Agreement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA_DEV_LLC_Work_for_Hire_Agreement+Updated.pdf',
    signPage: 5,
    coordinates: {
      x: 95,
      y: 450,
      height: 40,
      opacity: 1,
    },
    signNamePage: 0,
    coordinatesName: {
      x: 145,
      y: 628,
      size: 12,
    },
    signDatePage: 0,
    coordinatesDate: {
      x: 115,
      y: 616,
      size: 12,
    },
  },
  {
    type: 'SECURITY_CAMERA',
    title: 'Security Camera Notification',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Security+Camera+Notification.pdf',
    signPage: 0,
    coordinates: {
      x: 100,
      y: 250,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 90,
      y: 250,
      size: 12,
    },
    coordinatesDate: {
      x: 90,
      y: 223,
      size: 12,
    },
  },
  {
    type: 'UNIFORM_AND_MATERIALS',
    title: 'Employee Uniform and Materials Agreement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Employee+Uniform+%26+Materials+Agreement.pdf',
    signPage: 0,
    coordinates: {
      x: 100,
      y: 100,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 140,
      y: 548,
      size: 12,
    },
  },
  {
    type: 'DAILY_HEALTH_CHECK',
    title: 'Daily Health Check Acknowledgement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Daily+Health+Check+Acknowledgement.pdf',
    signPage: 0,
    coordinates: {
      x: 250,
      y: 153,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 155,
      y: 173,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 155,
      y: 173,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 155,
      y: 158,
      size: 12,
    },
  },
  {
    type: 'SOCIAL_COVENANT',
    title: 'Social Covenant Agreement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Social+Covenant+Agreement.pdf',
    signPage: 1,
    coordinates: {
      x: 230,
      y: 145,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 150,
      y: 162,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 150,
      y: 162,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 150,
      y: 147,
      size: 12,
    },
  },
  {
    type: 'POSITIVE_GUIDANCE',
    title: 'Positive Guidance Policy',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA_positive_guidance_policy_1.pdf',
    signPage: 2,
    coordinates: {
      x: 92,
      y: 525,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 92,
      y: 638,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 333,
      y: 536,
      size: 12,
    },
  },
  {
    type: 'CHILDREN_SPECIAL_ACCOMODATIONS',
    title: 'ECP for Children w/ Special Accommodations or Needs',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Emergency_Care_Plan_for_Children_with_Special_Accommodations_or_Needs.pdf',
    signPage: 2,
    coordinates: {
      x: 60,
      y: 570,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 60,
      y: 667,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 360,
      y: 590,
      size: 12,
    },
  },
  {
    type: 'SHAKEN_BABY_SYNDROME',
    title: 'Shaken Baby Syndrome Agreement & Policy',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Prevention_of_Shaken_Baby_Syndrome_and_Abusive_Head_Trauma_Policy__2_.pdf',
    signPage: 4,
    coordinates: {
      x: 60,
      y: 560,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 67,
      y: 678,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 430,
      y: 567,
      size: 12,
    },
  },
  {
    type: 'BLOODBORNE_PATHOGEN',
    title: 'Bloodborne Pathogen Training',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/Bloodborne+Pathogen+Training.pdf',
    signPage: 1,
    coordinates: {
      x: 250,
      y: 556,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 150,
      y: 584,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 150,
      y: 584,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 150,
      y: 570,
      size: 12,
    },
  },
  {
    type: 'BATHROOM_SUPERVISION',
    title: 'AEA Bathroom Supervision Policy',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA+Bathroom+Supervision+Policy.pdf',
    signPage: 0,
    coordinates: {
      x: 185,
      y: 139,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 90,
      y: 139,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 90,
      y: 139,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 130,
      y: 127,
      size: 12,
    },
  },
  {
    type: 'BABYSITTING_POLICY',
    title: 'AEA Babysitting Policy Acknowledgement',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA_Babysitting_Policy.pdf',
    signPage: 0,
    coordinates: {
      x: 160,
      y: 139,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 90,
      y: 139,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 90,
      y: 139,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
  },
  {
    type: 'PLAYGROUND_POLICY',
    title: 'AEA Playground Safety Policy',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA+Playground+Safety+Policy.pdf',
    signPage: 3,
    coordinates: {
      x: 210,
      y: 520,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 90,
      y: 514,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 90,
      y: 514,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
  },
  {
    type: 'DIRECT_SUPERVISION',
    title: 'AEA Direct Supervision & Security',
    url: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/AEA+Direct+Supervision+and+Security.pdf',
    signPage: 2,
    coordinates: {
      x: 230,
      y: 200,
      height: 40,
      opacity: 1,
    },
    coordinatesRectangle: {
      x: 145,
      y: 238,
      width: 100,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesName: {
      x: 145,
      y: 238,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 145,
      y: 225,
      size: 12,
    },
  },
  {
    type: 'MEDICATION_POLICY',
    title: 'AEA Medication Policy For Staff Members',
    url: 'https://arb-systems-s3-public.s3.amazonaws.com/public/Employment-Eligibility/AEA-Medication-Policy-for-Staff-Members.pdf',
    signPage: 0,
    coordinates: {
      x: 115,
      y: 120,
      height: 40,
      opacity: 1,
    },
    coordinatesName: {
      x: 118,
      y: 111,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesDate: {
      x: 300,
      y: 125,
      size: 12,
    },
  },
  {
    type: 'HANDBOOK_ACKNOWLEDGEMENT',
    title: 'AEA Handbook Acknowledgement',
    url: 'https://arb-systems-s3-public.s3.amazonaws.com/public/Employment-Eligibility/Handbook-Acknowledgement.pdf',
    signPage: 0,
    coordinates: {
      x: 130,
      y: 102,
      height: 25,
      opacity: 1,
    },
    coordinatesName: {
      x: 125,
      y: 125,
      size: 12,
      backgroundColor: rgb(0, 0, 0),
    },
    coordinatesRectangle: {
      x: 64,
      y: 77,
      width: 120,
      height: 20,
      color: rgb(1, 1, 1),
    },
    coordinatesDate: {
      x: 70,
      y: 77,
      size: 16,
    },
  },
  {
    type: 'EMPLOYEE_CHILDCARE_TUITION',
    title: 'Employee Childcare Tuition Agreement',
    url: 'https://arb-systems-s3-public.s3.amazonaws.com/public/Employee-Childcare-Tuition-Agreement.pdf',
    signPage: 1,
    coordinates: {
      x: 175,
      y: 118,
      height: 25,
      opacity: 1,
    },
    coordinatesFields: {
      employeeName: { page: 1, x: 150, y: 213, size: 11 },
      childrenEnrolled: { page: 1, x: 211, y: 169, size: 11 },
      preferredPaymentMethod: { page: 1, x: 218, y: 149, size: 11 },
      signatureDate: { page: 1, x: 70, y: 105, size: 11 },
    },
    eraseRectangles: [
      // White-out for "(circle one) Credit Card / Debit Card / ACH"
      { page: 1, x: 215, y: 145, width: 283, height: 20 },
    ],
  },
  {
    type: 'LAPTOP_CONTRACT',
    title: 'Laptop User Contract & Agreement',
    url: 'https://arb-systems-s3-public.s3.amazonaws.com/public/Contract-Laptops.pdf',
    signPage: 2,
    coordinates: {
      x: 150,
      y: 530,
      height: 25,
      opacity: 1,
    },
    coordinatesFields: {
      employeeNameHeader: { page: 0, x: 344, y: 639, size: 10 },
      initials1: { page: 0, x: 367, y: 515, size: 10 },
      initials2: { page: 0, x: 357, y: 495, size: 10 },
      initials3: { page: 0, x: 511, y: 475, size: 10 },
      initials4: { page: 0, x: 374, y: 457, size: 10 },
      initials5: { page: 0, x: 120, y: 425, size: 10 },
      initials6: { page: 0, x: 56, y: 394, size: 10 },
      initials7: { page: 0, x: 56, y: 363, size: 10 },
      initials8: { page: 0, x: 471, y: 343, size: 10 },
      initials9: { page: 0, x: 402, y: 313, size: 10 },
      initials10: { page: 0, x: 231, y: 259, size: 10 },
      initials11: { page: 0, x: 55, y: 227, size: 10 },
      initials12: { page: 0, x: 325, y: 195, size: 10 },
      initials14: { page: 0, x: 54, y: 135, size: 10 },
      noticeName: { page: 1, x: 118, y: 500, size: 10 },
      noticeAddress: { page: 1, x: 127, y: 488, size: 10 },
      noticeCityStateZip: { page: 1, x: 147, y: 475, size: 10 },
      noticeEmail: { page: 1, x: 117, y: 463, size: 10 },
      noticePhone: { page: 1, x: 121, y: 453, size: 10 },
      employeeSignedName: { page: 2, x: 88, y: 353, size: 10 },
      employeeSignedDate: { page: 2, x: 83, y: 328, size: 10 },
      schoolName: { page: 2, x: 121, y: 299, size: 10 },
      laptopMake: { page: 2, x: 86, y: 271, size: 10 },
      laptopModel: { page: 2, x: 91, y: 256, size: 10 },
      laptopSerial: { page: 2, x: 125, y: 243, size: 10 },
    },
  },
];

export const typeAndTitle = [
  { type: 'NON_DISCLOSURE', title: 'Non Disclosure Agreement' },
  { type: 'WORK_FOR_HIRE', title: 'Work for Hire Agreement' },
  {
    type: 'SECURITY_CAMERA',
    title: 'Security Camera Notification',
  },
  { type: 'UNIFORM_AND_MATERIALS', title: 'Employee Uniform and Materials Agreement' },
  {
    type: 'DAILY_HEALTH_CHECK',
    title: 'Daily Health Check Acknowledgement',
  },
  {
    type: 'SOCIAL_COVENANT',
    title: 'Social Covenant Agreement',
  },
  {
    type: 'POSITIVE_GUIDANCE',
    title: 'Positive Guidance Policy',
  },
  {
    type: 'CHILDREN_SPECIAL_ACCOMODATIONS',
    title: 'ECP for Children w/ Special Accommodations or Needs',
  },
  {
    type: 'SHAKEN_BABY_SYNDROME',
    title: 'Shaken Baby Syndrome Agreement & Policy',
  },
  {
    type: 'BLOODBORNE_PATHOGEN',
    title: 'Bloodborne Pathogen Training',
  },
  {
    type: 'BATHROOM_SUPERVISION',
    title: 'AEA Bathroom Supervision Policy',
  },
  {
    type: 'BABYSITTING_POLICY',
    title: 'AEA Babysitting Policy Acknowledgement',
  },
  {
    type: 'PLAYGROUND_POLICY',
    title: 'AEA Playground Safety Policy',
  },
  {
    type: 'DIRECT_SUPERVISION',
    title: 'AEA Direct Supervision & Security',
  },
  { type: 'MEDICATION_POLICY', title: 'AEA Medication Policy For Staff Members' },
  {
    type: 'HANDBOOK_ACKNOWLEDGEMENT',
    title: 'AEA Handbook Acknowledgement',
  },
  {
    type: 'EMPLOYEE_CHILDCARE_TUITION',
    title: 'Employee Childcare Tuition Agreement',
  },
  {
    type: 'LAPTOP_CONTRACT',
    title: 'Laptop User Contract & Agreement',
  },
];

export const dynamicAgreementConfig = {
  signPage: -1,

  acknowledgementText: {
    text:
      `I, {employeeName}, acknowledge that I have read, understood, ` +
      `and received a copy of the policy titled '{documentTitle}'.`,
    x: 80,
    y: 750,
    size: 12,
  },

  employeeBlock: {
    label: { text: 'Employee Signature', x: 80, y: 670, size: 10 },
    signature: {
      coordinates: { x: 80, y: 620, height: 40, width: 250 },
      line: { start: { x: 80, y: 615 }, end: { x: 330, y: 615 } },
    },
    printedName: {
      label: { text: 'Printed Name', x: 80, y: 590, size: 10 },
      coordinates: { x: 80, y: 575, size: 12 },
      line: { start: { x: 80, y: 570 }, end: { x: 330, y: 570 } },
    },
    date: {
      label: { text: 'Date', x: 400, y: 590, size: 10 },
      coordinates: { x: 400, y: 575, size: 12 },
      line: { start: { x: 400, y: 570 }, end: { x: 520, y: 570 } },
    },
  },

  // TODO: Uncomment if director block is necessary in the future
  // directorBlock: {
  //   label: { text: 'Accepted and Agreed To (Management Signature)', x: 80, y: 510, size: 10 },
  //   signatureLine: { start: { x: 80, y: 450 }, end: { x: 330, y: 450 } },
  //   nameLabel: { text: 'Printed Name', x: 80, y: 435, size: 10 },
  //   titleLabel: { text: 'Title', x: 80, y: 415, size: 10 },
  // },
};
